module.exports = __webpack_public_path__ + "static/media/hiw18.e228ad62.svg";